import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('./components/ClaudiaLayout.vue');
const EddieView = () => import('../eddie/pages/EddieView.vue');
const KnowledgeBaseMicrofrontend = () =>
  import(
    '../../../../microfrontends/knowledge-base/KnowledgeBaseMicrofrontend.vue'
  );
const ClaudiaControlledFlowsMicrofrontend = () =>
  import(
    '../../../../microfrontends/claudia/ClaudiaControlledFlowsMicrofrontend.vue'
  );
const ClaudiaAgentsView = () => import('./pages/ClaudiaAgentsView.vue');
const ClaudiaToolsView = () => import('./pages/ClaudiaToolsView.vue');
const ClaudiaMcpView = () => import('./pages/ClaudiaMcpView.vue');
const ClaudiaSettingsView = () => import('./pages/ClaudiaSettingsView.vue');
const ClaudiaDeployView = () => import('./pages/ClaudiaDeployView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/claudia'),
      name: 'claudia_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'cx_engineer'],
      },
      children: [
        {
          path: '',
          name: 'claudia_default',
          // Match parent's permissions so the global beforeEach guard's
          // `routeIsAccessibleFor` check passes for admins/cx_engineers.
          // Without this meta the empty child has no permissions array and
          // the legacy `validateLoggedInRoutes` redirects to /dashboard
          // before our beforeEnter ever fires.
          meta: { permissions: ['administrator', 'cx_engineer'] },
          beforeEnter: (to, from, next) => {
            const { accountId } = to.params;
            next(frontendURL(`accounts/${accountId}/claudia/agents`));
          },
        },
        {
          path: 'view',
          name: 'eddie_view_legacy',
          // The legacy /claudia/view route used to mount the entire Eddie
          // dashboard. The CRUD/dashboard portion has moved into the native
          // claudia-app ControlledFlows module — redirect any existing
          // bookmarks back to the new entry point instead of rendering the
          // old iframe-only page.
          redirect: to => ({
            name: 'claudia_agents',
            params: { accountId: to.params.accountId },
          }),
          meta: { permissions: ['administrator', 'cx_engineer'] },
        },
        {
          path: 'eddie',
          name: 'eddie_view',
          component: EddieView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_flows_v2',
            hideIfFeatureFlag: true,
          },
        },
        {
          path: 'controlled-flows',
          name: 'claudia_controlled_flows',
          component: ClaudiaControlledFlowsMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_flows_v2',
          },
        },
        {
          path: 'controlled-flows/*',
          name: 'claudia_controlled_flows_catchall',
          component: ClaudiaControlledFlowsMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_flows_v2',
          },
        },
        {
          // /tools/:workflowId/build (inline Eddie iframe inside the Tools
          // module). The catch-all keeps the sidebar's "Tools" entry active
          // because the route name still starts with `claudia_tools` (see
          // ClaudiaSecondarySidebar.vue → isActive uses .includes()).
          path: 'tools/*',
          name: 'claudia_tools_catchall',
          component: ClaudiaToolsView,
          meta: { permissions: ['administrator', 'cx_engineer'] },
        },
        {
          path: 'knowledge-bases',
          name: 'knowledge_base_view',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'knowledge-bases/*',
          name: 'knowledge_base_view_catchall',
          component: KnowledgeBaseMicrofrontend,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_knowledge_bases',
          },
        },
        {
          path: 'agents',
          name: 'claudia_agents',
          component: ClaudiaAgentsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'tools',
          name: 'claudia_tools',
          component: ClaudiaToolsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'mcp',
          name: 'claudia_mcp',
          component: ClaudiaMcpView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'settings',
          name: 'claudia_settings',
          component: ClaudiaSettingsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'deploy',
          name: 'claudia_deploy',
          component: ClaudiaDeployView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
            newFeatureFlag: 'enable_claudia_deploy',
          },
        },
      ],
    },
  ],
};
